import { BaseModel } from "./base.model";
import { Briefing } from "./briefing.model";
import { Moment } from "moment"

export class BriefingRegistration extends BaseModel<BriefingRegistration> {
  scheduledAt: Moment
  uuid: string
  state: string
  briefing: Briefing
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/briefing-registration.model.ts